/**
 * Recurso de tradução para elementos comuns
 */

import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { commonTranslationRef } from './common';

export const commonTranslations = createTranslationResource({
  ref: commonTranslationRef,
  translations: {
    'pt-BR': () => import('./common-pt-BR'),
  },
});
